var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConvertSalesforceLead = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M18.618 13.812c.171.17.177.45.012.628l-3.252 3.497a.77.77 0 0 1-1.125.012l-1.377-1.423a.455.455 0 0 1 0-.629.42.42 0 0 1 .608 0l1.325 1.37 3.201-3.443a.42.42 0 0 1 .608-.012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M13.779 8.903a2.154 2.154 0 1 1-4.308 0 2.154 2.154 0 0 1 4.308 0m-.772 0a1.382 1.382 0 1 1-2.764 0 1.382 1.382 0 0 1 2.764 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M13.25 12.022c1.445.247 2.24.79 2.61 1.127.189.172.265.423.265.68v.046a.387.387 0 0 1-.771 0v-.047a.3.3 0 0 0-.015-.105l-.003-.006-.003-.004-.003-.003c-.268-.24-.937-.718-2.25-.934a9 9 0 0 0-1.455-.112c-2.301 0-3.352.73-3.705 1.046a.03.03 0 0 0-.01.013.3.3 0 0 0-.014.105v.636c0 .284.23.515.515.515h2.07l.03-.002h.728a.386.386 0 1 1 0 .773H8.41c-.71 0-1.286-.576-1.286-1.286v-.636c0-.256.076-.507.266-.68.49-.446 1.727-1.255 4.234-1.255.54 0 1.02.037 1.446.1l.087.014z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConvertSalesforceLead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/convert-salesforce-lead.ad6ab639.svg";